/**
 * Single MSAL instance + React provider.
 *
 * The instance is exported so non-React modules (the API http client)
 * can acquire tokens from the same cache — creating a second
 * PublicClientApplication would split the token cache and break silent
 * acquisition.
 */

import type { ReactNode } from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './msalConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

export function AuthProvider({ children }: { children: ReactNode }) {
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
}
